import { render, staticRenderFns } from "./TableAction.vue?vue&type=template&id=4484cc96"
import script from "./TableAction.vue?vue&type=script&lang=ts"
export * from "./TableAction.vue?vue&type=script&lang=ts"
import style0 from "./TableAction.vue?vue&type=style&index=0&id=4484cc96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports